import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

/**
 * GET /api/v1/payments/next-period/?student=&package=
 * → { period_start, period_end } chained after the student's latest package.
 */
function useNextPeriod({ student, pkg } = {}) {
  return useQuery({
    queryKey: ["payments", "next-period", { student, pkg }],
    queryFn: () =>
      apiClient
        .get("/api/v1/payments/next-period/", {
          params: { student, package: pkg },
        })
        .then((r) => r.data),
    enabled: Boolean(student && pkg),
  });
}

export { useNextPeriod };
